import { useDispatch } from 'react-redux'

import { track, useTracking } from 'lib/analytics'
import { Registry } from 'src/types/registry'
import { RegItem } from 'src/types/regItem'
import { Reservation } from 'src/types/reservation'
import { createReservation } from 'registry/actions'
import { openReservePurchasedGiftModal } from 'registry/modals/actions'

export interface CreateEditReservationModalsProps {
  regItem: RegItem
  registry: Registry
  existingReservation?: Reservation
}

export const useOpenCreateEditReservationModal = ({
  regItem,
  registry,
  existingReservation,
}: CreateEditReservationModalsProps) => {
  // Because we are using the old modal flows for this, we need to use redux to manage the state and maintain compatibility.
  // Any calls to this function must be made within the context of a redux provider.
  const dispatch = useDispatch()
  const tracker = useTracking()

  return () =>
    dispatch(
      openReservePurchasedGiftModal(
        regItem,
        registry,
        getTrackedCreateReservation(tracker, dispatch),
        existingReservation
      )
    )
}

export const getTrackedCreateReservation =
  (tracker: any, dispatch: any) =>
  (...args: any) =>
    dispatch(createReservation(...args)).then(
      (newReservation: Record<string, unknown>) => {
        const { email, userId } = newReservation
        tracker.trackEvent({
          event: track.emailCaptured,
          eventLocation: track.EventLocation.REGISTRY_MINUS_GIFT_GIVER_VIEW,
          eventUrl: window.location.href,
          email,
          userId,
        })
        return newReservation
      }
    )
